import { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Pricing from "./components/Pricing";
import SeasonalOffer from "./components/SeasonalOffer";
import FAQ from "./components/FAQ";
import CTABanner from "./components/CTABanner";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

export const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=50251995814&text=Quisiera%20informaci%C3%B3n%20de%20los%20Bungalows%20de%20Berlisa%20del%20Pac%C3%ADfico.";

function App() {
  const [lang, setLang] = useState("es");

  return (
    <div className="App">
      <Navbar lang={lang} setLang={setLang} />
      <Hero lang={lang} />
      <About lang={lang} />
      <Services lang={lang} />
      <Gallery lang={lang} />
      <Pricing lang={lang} />
      <SeasonalOffer lang={lang} />
      <FAQ lang={lang} />
      <CTABanner lang={lang} />
      <Contact lang={lang} />
      <Footer lang={lang} />
      <ScrollToTop />
    </div>
  );
}

export default App;
